import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import BusinessDetailsForm from 'components/settings/businessDetails/components/BusinessDetailsForm';

export default function EntryPoint({ contextProps, wrappedProps }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <BusinessDetailsForm {...wrappedProps} />
      </AppWrapper>
    </QueryClientProvider>
  );
}
